/* ============================================================
   Типобезопасные хелперы для работы с DOM
   ============================================================ */

/** Найти элемент по id или бросить понятную ошибку. */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`[dom] Элемент #${id} не найден`);
  return el as T;
}

/** querySelector с типизацией (может вернуть null). */
export function qs<T extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T | null {
  return root.querySelector<T>(selector);
}

/** querySelectorAll → массив (удобно для forEach/map). */
export function qsa<T extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}
